@if (!isEditing) {
  <div class="flex items-center gap-2">
    <span>{{ variant?.name }}</span>
    <button (click)="startEdit()"
            class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300">
      <lucide-icon [name]="Edit" size="16"></lucide-icon>
    </button>
  </div>
} @else {
  <div class="flex items-center gap-2">
    <input
      type="text"
      [(ngModel)]="editedName"
      class="dark:bg-dark-900 h-11 rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400
    focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30
    dark:focus:border-brand-800"
      (keyup.enter)="saveEdit()"
      (keyup.escape)="cancelEdit()"
    >
    <button (click)="saveEdit()"
            class="text-green-500 hover:text-green-600 dark:hover:text-green-400">
      <lucide-icon [name]="Check" size="16"></lucide-icon>
    </button>
    <button (click)="cancelEdit()"
            class="text-red-500 hover:text-red-600 dark:hover:text-red-400">
      <lucide-icon [name]="X" size="16"></lucide-icon>
    </button>
  </div>
  @if(error) {
    <div class="text-red-600 text-sm mt-1">{{ error }}</div>
  }
}
